import React from 'react'

export const SettingsPage = () => {
  return (
    <div className="bg-[#2A2A3C] rounded-lg p-6">
      <h1 className="text-2xl font-bold text-white mb-6">Settings</h1>
      <div className="text-gray-300">
        Settings management coming soon...
      </div>
    </div>
  )
} 